/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { convertToSnakeCase } from './convertCase';

export const normalizeAttributes = (
  input: Record<string, any>,
  type = 'address'
) => {
  const baseKeys =
    type === 'address'
      ? [
          'region',
          'city',
          'company',
          'countryCode',
          'countryId',
          'defaultBilling',
          'defaultShipping',
          'fax',
          'firstName',
          'lastName',
          'middleName',
          'postcode',
          'prefix',
          'street',
          'suffix',
          'telephone',
          'vatId',
          'addressId',
        ]
      : [
          'email',
          'firstName',
          'lastName',
          'middleName',
          'gender',
          'dob',
          'prefix',
          'suffix',
          'fax',
        ];

  const result: Record<string, any> = {};
  const customAttributes: Record<string, any>[] = [];

  Object.keys(input).forEach((key: string) => {
    if (baseKeys.includes(key)) {
      result[key] = input[key];
    } else {
      customAttributes.push({
        attribute_code: convertToSnakeCase(key),
        value: input[key],
      });
    }
  });

  if (customAttributes.length > 0) {
    result.custom_attributesV2 = customAttributes;
  }

  return result;
};
